import Vue from 'vue';
import VueRouter from 'vue-router';
import Landing from '../views/Landing.vue';
import Home from '../views/Home.vue';
import ArtClub from '../views/ArtClub.vue';
import ArtClubStudy from '../views/art-club/Study.vue';
import Admin from '../views/Admin.vue';
import { authGuard, adminGuard } from './guards';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      authGuard(next);
    },
  },
  {
    path: '/profile',
    component: () => import('@/views/Profile.vue'),
    name: 'profile',
    children: [
      {
        path: ':username',
      },
    ],
    meta: {
      title: 'My Profile / Maddy App',
    },
  },
  {
    path: '/profile/:username',
    name: 'user',
    component: () => import('@/views/Profile.vue'),
    meta: {
      title: 'Profile / Maddy App',
    },
  },
  {
    path: '/art-club',
    name: 'art-club',
    component: ArtClub,
    meta: {
      title: 'Art Club / Maddy App',
    },
  },
  {
    path: '/teacher/:id',
    name: 'teacher-gallery',
    component: () => import('@/views/TeacherGallery.vue'),
  },
  {
    path: '/art-club/:id',
    name: '',
    component: ArtClubStudy,
    meta: {
      title: 'Study / Maddy App',
    },
    children: [
      {
        path: '',
        name: 'art-club-study',
        component: () => import('@/views/art-club/StudyResources.vue'),
        meta: {
          title: 'Study Resources / Maddy App',
        },
      },
      {
        path: 'gallery',
        name: 'art-club-study-gallery',
        component: () => import('@/views/art-club/StudyGallery.vue'),
        meta: {
          title: 'Study Gallery / Maddy App',
        },
      },
      {
        path: 'submission/:submission',
        name: 'art-club-study-submission',
        component: () => import('@/views/art-club/StudySubmission.vue'),
        meta: {
          title: 'Study Submission / Maddy App',
        },
      },
      {
        path: 'submissions',
        name: 'art-club-study-submit',
        component: () => import('@/views/art-club/StudyMySubmissions.vue'),
        meta: {
          title: 'My Study Submissions / Maddy App',
        },
      },
    ],
  },
  {
    path: '/admin',
    name: '',
    component: Admin,
    beforeEnter: (from, to, next) => {
      adminGuard(next);
    },
    children: [
      {
        path: '',
        name: 'admin',
        component: () => import('@/views/admin/Dashboard.vue'),
      },
      {
        path: 'studies',
        name: 'admin-studies',
        component: () => import('@/views/admin/Studies.vue'),
      },
      {
        path: 'studies/:id',
        name: 'admin-study',
        component: () => import('@/views/admin/Study.vue'),
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('@/views/admin/Users.vue'),
      },
      {
        path: 'rewards',
        name: 'admin-rewards',
        component: () => import('@/views/admin/Rewards.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];

  if (!publicPages.includes(to.path)) {
    authGuard(next);
  }

  next();
});

export default router;
